import React, { useEffect, useState } from "react";
import { getCommunications, deleteDomain } from "../../api/fiches";
import { useNavigate } from "react-router-dom";

export default function FichesList({ onEdit }) {
  const [fiches, setFiches] = useState([]);
  const [view, setView] = useState(null);
  const [openRow, setOpenRow] = useState(null);
  const navigate = useNavigate();

  const loadFiches = async (url) => {
    const data = await getCommunications(url);
    setFiches(data.items);
    setView(data.view);
  };

  useEffect(() => {
    loadFiches();
  }, []);

  const goTo = (url) => {
    loadFiches("http://localhost:8080" + url);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer cette commission ?")) {
      await deleteDomain(id);
      loadFiches();
    }
  };

  return (
      <div>
        <h2>Liste des Fiches</h2>
        <div className="table-responsive">
          <table className="table table-selectable card-table table-vcenter text-nowrap datatable">
          <tbody>
          {fiches.map((d) => (
              <React.Fragment key={d.comId}>
                <tr>
                  <td>{d.comLib}</td>
                  <td>
                    <button
                        className="btn fr-btn btn fr-btn--secondary"
                        onClick={() => navigate(`/fiches/${d.comId}/domaines`, { state: { commission: d } })}
                    >
                      Domaines
                    </button>
                  </td>
                  <td>
                    <button className="btn fr-btn" onClick={() => onEdit(d)}>Modifier</button>
                    <button
                        className="btn fr-btn btn fr-btn--secondary"
                        onClick={() => handleDelete(d.comId)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>

                {openRow === d.comId && (
                    <tr>
                      <td colSpan="5">
                        <strong>Domaines associés :</strong>
                        {d.domaines?.length ? (
                            <ul>
                              {d.domaines.map(dom => (
                                  <li key={dom.domId}>{dom.domLib}</li>
                              ))}
                            </ul>
                        ) : (
                            <em>Aucun domaine</em>
                        )}
                      </td>
                    </tr>
                )}
              </React.Fragment>
          ))}
          </tbody>
        </table>
      </div>
      </div>
  );
}
